import "%modules%/header/header";
import "%components%/how-it-work/how-it-work";
